<template>
    <App>
        <div class="quote">
            <div class="quote-container">
                <h1 class="quote-text" v-html="text"></h1>
                <h2 class="quote-author">{{ author }}</h2>
            </div>
        </div>
    </App>
</template>

<script>
import App from "@/components/App";

export default {
    name: "Index",
    components: {App},
    props: {
        text: {
            type: String,
            required: true
        },
        author: {
            type: String,
            required: true
        },
    }
}
</script>